import React from "react";
import { MetricsCard } from "@/components/ui/metrics-card";
import { Banknote, ArrowUp, ArrowDown, Hash } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface TransactionStatProps {
  isLoading?: boolean;
  pointsTitle?: string;
  pointsDescription?: string;
  stats?: {
    totalTransactions: number;
    totalValue: React.ReactNode;
    pointsEarned: number;
    pointsBurned: number;
    avgPointsPerTransaction: number;
  };
}

export const TransactionStats: React.FC<TransactionStatProps> = ({
  isLoading = false,
  pointsTitle = "Points Accrued",
  pointsDescription = "Total points Accrued",
  stats = {
    totalTransactions: 0,
    totalValue: "$0.00",
    pointsEarned: 0,
    pointsBurned: 0,
    avgPointsPerTransaction: 0,
  },
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="bg-white rounded-lg p-5 shadow-sm">
            <Skeleton className="h-4 w-28 mb-2" />
            <Skeleton className="h-8 w-24 mb-2" />
            <Skeleton className="h-4 w-20" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <MetricsCard
        title="Total Transactions"
        value={stats.totalTransactions.toLocaleString("en-US")}
        icon={<Hash className="h-5 w-5" />}
        description="All processed transactions"
      />
      <MetricsCard
        title={pointsTitle}
        value={stats.pointsEarned.toLocaleString("en-US")}
        icon={<ArrowUp className="h-5 w-5" />}
        description={pointsDescription}
      />
      <MetricsCard
        title="Total Value"
        value={stats.totalValue}
        icon={<Banknote className="h-5 w-5" />}
        description="Transaction monetary value"
      />
    </div>
  );
};
